import React from "react";
import {
  fill_heart,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../../assets";
import { useNavigate } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import { updateFavoriteListHandler } from "./LikeUnlikeHeart";
import { GroupCardSkeleton } from "../../../../shimmer/groups/GroupsListingShimmer";
import InfiniteScroll from "react-infinite-scroll-component";
import NotFoundPlaceHolder from "../../../../components/not-found/NotFoundPlaceHolder";
import FlatList from "components/FlatList";
import LazyImage from "components/common/Image";

const JoinedGroup = ({
  groupList,
  fetchMoreData,
  hasMore,
  setGroupList,
  loading,
}) => {
  const navigate = useNavigate();
  //--------navigate-details-page--------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  return (
    <>
      <div className="CategoriesGroupsList_parent">
        <div id="scrollableContainer" className="CategoriesGroupsList_cards">
          {groupList.length > 0 || loading ? (
            <InfiniteScroll
              dataLength={groupList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<GroupCardSkeleton count={5} />}
              scrollableTarget="scrollableContainer"
            >
              <div className="health_hub_cards">
                <FlatList
                  data={groupList}
                  renderItem={(data) => {
                    return (
                      <div key={data?._group?._id} className="health_hub_img">
                        {/* <Link to={`/dashboard/group/detail/${data?._group?._id}`} ></Link> */}

                        <div
                          onClick={() => navigateDetailsPage(data?._group?._id)}
                          className="image_containerss pointer-cursor"
                        >
                          <LazyImage src={data?._group?.coverImage} alt="" />
                          <div className="health_hub_img_text">
                            <h6>{data?._group?.name}</h6>
                            <p>
                              {data?._group?.newFeeds?.count > 0 ? (
                                <>
                                  <GoDotFill className="live_dot" />
                                  {`${data?._group?.newFeeds?.count} New Post${
                                    data?._group?.newFeeds?.count > 1 ? "s" : ""
                                  }`}
                                </>
                              ) : null}
                            </p>
                          </div>
                        </div>

                        <div className="health_hub_containt">
                          <span className="tag dark">{data?._group?._parent?.name || data?._group?.categoryName}</span>

                          <figure className="health_hub_icons">
                            {data?._group?.type === "SUBSCRIPTION" && (
                              <img
                                src={subscription_icon}
                                className="lockimg"
                                alt=""
                              />
                            )}
                            {data?._group?.type === "PRIVATE" && (
                              <img src={lock_icon} className="lockimg" alt="" />
                            )}
                            <img
                              src={
                                data?.favoriteGroup?.status === "ACTIVE"
                                  ? fill_heart
                                  : heart_icon
                              }
                              className="heartimg"
                              alt=""
                              onClick={() =>
                                updateFavoriteListHandler(
                                  data?._group?._id,
                                  setGroupList,
                                  data?.favoriteGroup?.status === "ACTIVE"
                                    ? "INACTIVE"
                                    : "ACTIVE"
                                )
                              }
                            />
                          </figure>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            </InfiniteScroll>
          ) : (
            <NotFoundPlaceHolder title="No Groups available" />
          )}
        </div>
      </div>
    </>
  );
};

export default JoinedGroup;
